module.exports = __webpack_public_path__ + "img/整合营销_1@2x.c9710f5e.png";